import React from "react";
import Skeleton from "react-loading-skeleton";

const EditProfileLoader = () => {


    return (
        <div className="content_sec wf-section">
            <div className="login_sec w-form">
                <ul className="edit_pict_list w-clearfix w-list-unstyled">
                    {Array(1)
                        .fill(0)
                        .map((item, index) => (
                            <li className="edit_pict_item big" key={index}>
                                <Skeleton
                                    height={"100%"}
                                    style={{ zIndex: 0, lineHeight: 2 }}
                                />
                            </li>
                        ))}
                    {Array(5)
                        .fill(0)
                        .map((item, index) => (
                            <li className="edit_pict_item" key={index}>
                                <Skeleton
                                    height={"100%"}
                                    style={{ zIndex: 0, lineHeight: 2 }}
                                />
                            </li>
                        ))}
                </ul>
                <ul className="edit_info_list w-list-unstyled">
                    {Array(3)
                        .fill(0)
                        .map((item, index) => (
                            <li key={index}>
                                <Skeleton
                                    height={80}
                                    style={{ zIndex: 0, lineHeight: 2, marginBottom: 15 }}
                                />
                            </li>
                        ))}

                </ul>
            </div>
        </div>
    )
}

export default EditProfileLoader;